<template>
  <AwardBanner
    :banner-data="bannerContent"
  />
</template>

<script>
import AwardBanner from 'www/vue_components/common/Award/components/common/AwardBanner.vue'
import { getCurrentMoscowDate } from 'www/vue_components/common/Award/functions'
import { EVENT_DATES, CONTENT_BY_DATE } from 'www/vue_components/common/Award/constants'

export default {
  name: 'Award', // eslint-disable-line
  components: {
    AwardBanner,
  },
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
  computed: {
    currentDateIndex() {
      const currentMoscowDate = getCurrentMoscowDate()

      if (currentMoscowDate >= EVENT_DATES.at(-1)) {
        return EVENT_DATES.length - 1
      }

      return EVENT_DATES.findIndex(date => currentMoscowDate <= date) - 1
    },
    bannerContent() {
      if (this.currentDateIndex < 0) {
        return null
      }

      return CONTENT_BY_DATE[this.currentDateIndex]
    },
  },
}
</script>
